import { TextModuleFields, TextModuleProps } from "../types/TextModule.types";
import { StringField } from "../../../types/types";

export class TextModuleModel {
  private readonly fields: TextModuleFields;

  constructor(props: TextModuleProps) {
    this.fields = props.fields;
  }

  get description(): StringField {
    return this.fields?.Description
  }



  get title(): StringField {
    return this.fields?.Title;
  }


  get textPosition(): StringField {
    return (
      this.fields?.Alignment?.fields?.Key
    );
  }

}
